import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import Image from "next/image";

const FeaturedSlider = ({ logos }) => {
  // Filter out invalid logos (null, undefined, empty strings)
  const validLogos = logos?.filter(logo => logo && typeof logo === 'string' && logo.trim() !== '') || [];

  // Don't render anything if no valid logos
  if (validLogos.length === 0) {
    return null;
  }

  return (
    <div className='relative w-full'>
      <Swiper
        modules={[Autoplay]}
        slidesPerView={"auto"}
        autoplay={
          validLogos.length > 13
            ? {
                delay: 2000,
              }
            : false
        }
        loop={validLogos.length > 13}
        spaceBetween={40}
        className=''
      >
        {validLogos.map((logo, index) => (
          <SwiperSlide key={index} className='!w-auto'>
            <Image
              src={logo}
              alt='Slider Image'
              className='h-6 lg:h-7'
              width={85}
              height={50}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className='absolute top-0 right-0 z-10 w-48 h-full select-none bg-gradient-to-r from-transparent to-background'></div>
    </div>
  );
};

export default FeaturedSlider;
